(function () {
  function isWithinAnnouncementWindow(announcement) {
    var now = Math.floor(Date.now() / 1000);
    var starts = Number(announcement.getAttribute('data-announcement-starts'));
    var ends = Number(announcement.getAttribute('data-announcement-ends'));

    if (starts && starts > now) return false;
    if (ends && ends < now) return false;

    return true;
  }

  function isCurrentAnnouncement(announcement) {
    var slide = announcement.closest('.slideshow__slide');

    if (slide) {
      return slide.getAttribute('aria-hidden') !== 'true' && isWithinAnnouncementWindow(announcement);
    }

    return isWithinAnnouncementWindow(announcement);
  }

  function hasCurrentAnnouncement() {
    return Array.from(document.querySelectorAll('[data-announcement-discount]')).some(isCurrentAnnouncement);
  }

  function updateCheckoutSaleMessages() {
    var hasActiveAnnouncement = hasCurrentAnnouncement();

    document.querySelectorAll('[data-checkout-sale-message]').forEach(function (message) {
      message.hidden = !hasActiveAnnouncement;
    });
  }

  document.addEventListener('DOMContentLoaded', updateCheckoutSaleMessages);
  document.addEventListener('shopify:section:load', updateCheckoutSaleMessages);

  new MutationObserver(updateCheckoutSaleMessages).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();